interface ToggleButtonProps {
  handleToggle: (_data: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  checked: boolean;
  className?: string;
  style?: React.CSSProperties;
  circleWidth?: string;
  circleHeight?: string;
}
const ToggleButton = ({
  handleToggle,
  checked,
  className,
  style,
  circleWidth,
  circleHeight,
}: ToggleButtonProps) => {
  const height = style?.height || '20px';
  const computedStyle = {
    backgroundColor: style?.backgroundColor,
    height,
    width: `calc(${typeof height === 'string' ? height : `${height}px`} * 2)`,
  };
  const translateXValue = height;

  return (
    <div
      style={{
        ...computedStyle,
      }}
      className={`w-10 h-5 flex items-center bg-blue-100 rounded-full p-1 cursor-pointer transition-colors duration-300 ease-in-out ${
        checked ? 'bg-blue-400' : ''
      } ${className}`}
      onClick={handleToggle}>
      <div
        className={`w-4 h-4  rounded-full shadow-md transform transition-transform duration-300 ease-in-out`}
        style={{
          backgroundColor: style?.color,
          width: circleWidth || '16px',
          height: circleHeight || '16px',
          transform: checked ? `translateX(${translateXValue})` : undefined,
        }}></div>
    </div>
  );
};

export default ToggleButton;
